<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <div v-if="item.url">
      <a href="#" @click="openNextStage()">
        <b-row v-if="item.id">
          <b-col>
            <span v-if="item.willExpire" class="task-lane-item-id"
              ><div class="cargo-priority">#{{ item.id }}</div></span
            >
            <span v-else class="task-lane-item-id">#{{ item.id }}</span>
          </b-col>

          <b-col>
            <div class="time">
              <div class="d-inline pt-3">
                {{ item.elapsedTime }}
              </div>
              <div class="d-inline ml-1">
                <i class="tim-icons icon-time-alarm"></i>
              </div>
              <div v-if="item.willExpire" class="d-inline ml-1">
                <b-icon
                  icon="exclamation-circle-fill"
                  variant="danger"
                  v-b-tooltip.hover
                  title="Esta carga está expirando em breve"
                ></b-icon>
              </div>
            </div>
          </b-col>
        </b-row>
        <div class="pre-formatted">{{ item.text }}</div>
        <div
          v-if="item.checklistId != null && item.checklistId != ''"
          class="pre-formatted"
        >
          Checklist ID:

          <router-link :to="urlChecklist">
            <span class="task-lane-item-id">#{{ item.checklistId }}</span>
          </router-link>
        </div>
      </a>
      <div class="div-actions">
        <!-- <div>{{item.lastStatusLatitude}}</div> -->
        <!-- <div>{{item.lastStatusLongitude}}</div> -->
        <kanban-settings
          v-if="item.url"
          ref="kanbanSettings"
          :latitude="item.lastStatusLatitude"
          :longitude="item.lastStatusLongitude"
          :id="item.id"
          :urlChecklist="urlChecklist"
          :item="item"
          @confirmEdit="refreshData"
        ></kanban-settings>
      </div>

      <div>
        <!-- <div v-for="row in item" :key="row.id">
          {{row}}
        </div> -->
        <!-- <div v-for="row in item.cte" :key="row.id"> -->
        <!-- {{row}} -->
        <!-- <div>
            <b-row class="CTe">
              <b-col>
                <a href="#" @click="generatePdf('1', row.accessKey)">
                  <h5>CT-e: {{ row.number }} Série: {{ row.serie }}</h5>
                </a>
              </b-col>
            </b-row>
          </div>
        </div> -->
        <!-- <div v-for="row in item.mdfe" :key="row.id">
          <b-row class="MDFe">
            <b-col>
              <a href="#" @click="generatePdf('2')">
                <h5 class="task-lane-item-id">
                  <h5>MDF-e: {{ row.number }} Série: {{ row.serie }}</h5>
                </h5>
              </a>
            </b-col>
          </b-row>
        </div> -->
        <!-- <div v-for="row in item.contract" :key="row.id">
          <b-row class="MDFe">
            <b-col>
              <a href="#" @click="generatePdf('3')">
                <h5 class="task-lane-item-id">
                  <h5>Contrato de Frete: {{ row.number }} </h5>
                </h5>
              </a>
            </b-col>
          </b-row> -->
        <!-- </div> -->
      </div>
      <!-- <div>{{ item }}</div> -->
    </div>

    <b-modal
      ref="openModal"
      class="task-lane-item-modal"
      title="Exportar PDF"
      scrollable
      size="sm"
      :cancel-disabled="true"
    >
      <b-row>
        <b-col>
          <label for="">Isso pode demorar alguns minutos</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-icon
            icon="arrow-clockwise"
            animation="spin"
            font-scale="4"
          ></b-icon>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="openModalDanger" title="Exportar PDF" scrollable size="sm">
      <b-row>
        <b-col>
          <label for="">A CT-e não pode ser encotrada no sistema da GW</label>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "CargoKanbanCardCargo",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    KanbanSettings: () => import("@/components_rms/kankan/KanbanSettings.vue"),
  },
  props: ["item"],
  data: function () {
    return {
      urlChecklist: "",
      accessKey: "",
      urlCte: "",
      urlMap: "",
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
    };
  },
  created: function () {
    if (this.item) {
      if (this.item.url2) {
        this.urlChecklist = this.item.url2;
      } else if (this.item.checklistId) {
        this.urlChecklist = `/trackingShippingCompany/checklist/fill/${this.item.checklistId}`;
        this.loadNewUrl(this.item.checklistId);
      }
    }
  },
  methods: {
    async loadNewUrl(checklistId) {
      if (checklistId) {
        this.$apiChecklist
          .get(`/v2/checklist/get/${checklistId}`)
          .then((response) => {
            let checklist = response.data;
            if (checklist) {
              if (checklist.draft == false) {
                this.urlChecklist = `/trackingShippingCompany/checklist/filled/details/${checklistId}`;
                // this.$router.push({
                //   path: `/trackingShippingCompany/checklist/filled/details/${checklistId}`,
                // });
              }
            }
            // this.$router.push({
            //   path: `/trackingShippingCompany/checklist/fill/${checklistId}`,
            // });
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          });
      }
    },
    modalOpen() {
      this.$refs.openModal.show();
    },
    openModalDanger() {
      this.$refs.openModalDanger.show();
    },
    openNextStage() {
      this.$refs.kanbanSettings.openEditModal();
    },
    generatePdf(model, key) {
      this.modalOpen();
      console.log(key);
      this.accessKey = key;
      if (model == 1)
        this.url = `/GeneratePdf/${this.item.id}/cte/${this.accessKey}`;
      else if (model == 2)
        this.url = `/GeneratePdf/${this.item.id}/mdfe/${this.accessKey}`;
      else this.url = `/GeneratePdf/${this.item.id}/contract/${this.accessKey}`;
      this.$api
        .request({
          url: this.url,
          method: "POST",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          console.log("response");
          console.log(response);
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$refs.openModal.hide("modal-prevent-closing");
        })
        .catch((error) => {
          console.log("error");
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
              this.$refs.openModal.hide("modal-prevent-closing");
            });
            this.$refs.openModal.hide("modal-prevent-closing");
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log("Load data error");
                this.$refs.openModal.hide("modal-prevent-closing");
              } else if (error.response.status == 500) {
                this.alert.error = "CT-e nã encotrata na GW";
                this.$refs.openModal.hide("modal-prevent-closing");
                this.openModalDanger();
                this.$refs.danger.show();
              } else {
                console.log(error.response.statusText);
                this.$refs.openModal.hide("modal-prevent-closing");
              }
            } else {
              console.log(error.message);
              this.$refs.openModal.hide("modal-prevent-closing");
            }
            this.$refs.openModal.hide("modal-prevent-closing");
          }
        });

      // console.log(this.url.url);
    },
    refreshData() {
      this.$emit("refreshData");
    },
  },
};
</script>

<style>
.pre-formatted {
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style scoped>
.CTe {
  white-space: pre;
  margin-top: -6% !important;
  size: 12px;
}
.MDFe {
  white-space: pre;
  margin-top: -8% !important;
}
.task-lane-item-modal {
  text-align: center !important;
}
.div-actions {
  /* font-size: medium; */
  font-size: 16px;
  text-align: center;
  height: 20px;
  margin-left: -10px;
  margin-right: -10px;
  margin-top: 10px;
  padding-top: 5px;
}
</style>
